import React, { useState, useEffect } from "react";
import styles from "./LabelGeneratorConfirmationBox.module.css";
import { useLocation } from "react-router-dom";
import { delay, getCarrier } from "../utils/common";

const LabelGeneratorConfirmationBox = ( { data, selectedCarrier } ) => {
	const apiUrl = process.env.REACT_APP_API_URL;
	const location = useLocation();
    const token = localStorage.getItem("authToken");
    const [isLoading, setIsLoading] = useState(true);
    const [carrierName, setCarrierName] = useState("");
    const [carrierService, setCarrierService] = useState("");
    const [carrierRate, setCarrierRate] = useState(0);
    const [rates, setRates] = useState(null);
    const [referenceNumber, setReferenceNumber] = useState("");
    const formatAddress = (address) => { return `${address.name}, ${address.street1}${address.street2 ? ", " + address.street2 : ""}, ${address.city}, ${address.state}, ${address.zip}, ${address.country}`; };
    const toAddress = formatAddress(data.to_address);
    const fromAddress = formatAddress(data.from_address);

    useEffect(() => {
        const fetchLabelData = async () => {
            try {
            	if (!isLoading) { setIsLoading(true); }
                const response = await fetch(`${apiUrl}/api/get_label_data/`, { 
                	method: "POST", 
                	headers: { 
                		"Content-Type": "application/json",
                		"Authorization": `Bearer ${token}`
                	},
                	body: JSON.stringify(data)
                });
                const rates = await response.json();
                //use cheapest of both usps and ups by default
         		setCarrierName(getCarrier(rates.cheapest_rate.carrier)); 
         		setCarrierService(rates.cheapest_rate.service);
         		setCarrierRate(rates.cheapest_rate.rate);
                setIsLoading(false);
                setRates(rates);
            } catch (error) {
            	console.log(error)
                alert("Error fetching label. Please make sure to address, from address, and package dimensions are valid.");
                setIsLoading(false);
            }
        };
        fetchLabelData();
    }, []);

    //change rates displayed based on carrier selected by user in generator on confirm details view
    useEffect(() => {
    	if (!rates) { return; }
    	if (selectedCarrier === "cheapest") {
    		setCarrierName(getCarrier(rates.cheapest_rate.carrier)); 
         	setCarrierService(rates.cheapest_rate.service);
         	setCarrierRate(rates.cheapest_rate.rate);
    	} else if (selectedCarrier === "usps") {
    		setCarrierName(getCarrier(rates.cheapest_usps_rate.carrier)); 
         	setCarrierService(rates.cheapest_usps_rate.service);
         	setCarrierRate(rates.cheapest_usps_rate.rate);
    	} else if (selectedCarrier === "ups") {
    		setCarrierName(getCarrier(rates.cheapest_ups_rate.carrier)); 
         	setCarrierService(rates.cheapest_ups_rate.service);
         	setCarrierRate(rates.cheapest_ups_rate.rate);
    	}
    }, [selectedCarrier])

	return (
		<div className={styles.confirmation_box}>
			{isLoading && (<img className={styles.label_generator_confirmation_box_loader} src={`${process.env.PUBLIC_URL}/images/shipwheel_loader.gif`} />)}
			{!isLoading && (
				<>
					<div className={`${styles.carrier_box_segment} fade_in`}>
						<img src={`${process.env.PUBLIC_URL}/images/${carrierName.toLowerCase()}_logo.png`} alt="carrier_logo" className={styles.carrier_logo} />
						<div className={styles.carrier_service_and_rate_box}>
							<p className={styles.carrier_service}>{carrierService}</p>
							<p className={styles.carrier_rate}>Lowest rate: ${carrierRate}</p>
						</div>
					</div>
					<div className={`${styles.address_segment} fade_in`}>
						<div className={styles.segment_tag_wrapper}>
							<p className={styles.segment_tag}>To: </p>
						</div>
						<div className={styles.address_wrapper}>
							<p className={styles.address}>{toAddress}</p>
						</div>
					</div>
					<div className={`${styles.address_segment} fade_in`}>
						<div className={styles.segment_tag_wrapper}>
							<p className={styles.segment_tag}>From: </p>
						</div>
						<div className={styles.address_wrapper}>
							<p className={styles.address}>{fromAddress}</p>
						</div>
					</div>
					<div className={`${styles.weight_and_dimensions_segment} fade_in`}>
						<p className={styles.weight_and_dimensions}>Length: <span style={{ fontWeight: "bold" }}>{data.parcel.length}</span> in.&nbsp;&nbsp;Width: <span style={{ fontWeight: "bold" }}>{data.parcel.width}</span> in.&nbsp;&nbsp;Height: <span style={{ fontWeight: "bold" }}>{data.parcel.height}</span> in.&nbsp;&nbsp;Weight: <span style={{ fontWeight: "bold" }}>{data.parcel.weight}</span> oz.</p>
					</div>
				</>
			)}
		</div>	
	);
};

export default LabelGeneratorConfirmationBox;